import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import StudentTrainingModalHeader from './StudentTrainingModalHeader';
import TrainingRegister from './TrainingRegister';
import styles from './TrainingRegisterModal.module.css';

interface TrainingRegisterModalProps {
  open: boolean;
  studentId: string;
  studentTrainingId: string;
  onClose: () => void;
}

const TrainingRegisterModal: React.FC<TrainingRegisterModalProps> = ({
  open,
  studentId,
  studentTrainingId,
  onClose,
}) => {
  useEscapeToClose(onClose, open);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Editar treino da aluna"
    >
      <StudentTrainingModalHeader studentId={studentId} />
      <div className={styles.body}>
        <TrainingRegister
          key={studentTrainingId}
          studentId={studentId}
          studentTrainingId={studentTrainingId}
          onClose={onClose}
        />
      </div>
    </div>,
    document.body,
  );
};

export default TrainingRegisterModal;
